import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Config } from '@vendor/config/config';
@Injectable({
  providedIn: 'root'
})
export class BaseInfoService {
  constructor(private config: Config, private http: HttpClient) { }

  getAvailablePackage(): Observable<any> {
    const url = this.config.serverUrl + `api/v1/package`;
    return this.http.get<any>(url, {});
  }
  getAvailablePackageOption(): Observable<any> {
    const url = this.config.serverUrl + `api/v1/package/available-options`;
    return this.http.get<any>(url, {});
  }
  getAllBanks(): Observable<any> {
    const param = {};
    const url = this.config.serverUrl + `api/baseInfo/banks`;
    return this.http.get(url, param);
  }

  getAvailableAction(): Observable<any> {
    const url = this.config.serverUrl + `api/v1/action`;
    return this.http.get(url, {});
  }
  getMostUsedServices(): Observable<any> {
    const url = this.config.serverUrl + `api/baseInfo/useful-services`;
    return this.http.get(url, {});
  }
  checkAppUpdate(param): Observable<any> {
    const url = this.config.serverUrl + `api/version/check`;
    return this.http.post(url, param);
  }
  getLinks(): Observable<any> {
    const url = this.config.serverUrl + `api/baseInfo/useful-links`;
    return this.http.get(url, {});
  }
  getAppservices(): Observable<any> {
    const url = this.config.serverUrl + `api/baseInfo/appServices`;
    return this.http.get(url, {});
  }
  checkProfileSummary(): Observable<any> {
    const url = this.config.serverUrl + `api/user/profileSummary`;
    return this.http.get<any>(url, {});
  }
  getMobileOperators(): Observable<any> {
    const url = this.config.serverUrl + `api/baseInfo/mobileOperators`;
    return this.http.get<any>(url, {});
  }
  getSuggestionTypes(): Observable<any> {
    const url = this.config.serverUrl + 'api/baseInfo/suggestion-types';
    return this.http.get(url, {});
  }
  // immediate charge code
  getImPrices(): Observable<any> {
    const url = this.config.serverUrl + `api/v2/baseInfo/topUpAmounts`;
    return this.http.get<any>(url, {});
  }
  // charge code check-id-scan
  getPrices(): Observable<any> {
    const url = this.config.serverUrl + `api/baseInfo/availablePinCharges`;
    return this.http.get<any>(url, {});
  }
  // bill types
  getBillTypes(): Observable<any> {
    const url = this.config.serverUrl + `api/baseInfo/billTypes`;
    return this.http.get<any>(url, {});
  }
  getCompaniesBills(): Observable<any> {
    const url = this.config.serverUrl + 'api/baseInfo/bill-companies';
    return this.http.get(url, {});
  }
  getPayaReason(): Observable<any> {
    const url = this.config.serverUrl + 'api/ach/reasons';
    return this.http.get(url, {});
  }
  getPayaSatnaReason(): Observable<any> {
    const url = this.config.serverUrl + 'api/ach/v2/reasons';
    return this.http.get(url, {});
  }
  getProfileSummery(): Observable<any> {
    const url = this.config.serverUrl + `api/user/profileSummary`;
    return this.http.get(url, {});
  }
  getMobileOperatorOptions(): Observable<any> {
    const url = this.config.serverUrl + 'api/v2/baseInfo/mobileOperatorOptions';
    return this.http.post(url, {});
  }
}
